import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatIconModule } from '@angular/material/icon';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'formly-repeat-section',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, MatIconModule, FormlyModule, FormlyMaterialModule],
    template: `
        @if (formState.editMode) {
            <div>
                <legend *ngIf="props.label" class="mb-3">
                    <span class="font-semibold text-lg">{{ props.label }}</span>
                </legend>
                <p class="mb-3" *ngIf="props.description">
                    {{ props.description }}
                </p>
                @for (field of field.fieldGroup; track field.id; let i = $index) {
                <div class="relative">
                    <formly-field
                        class="w-full"
                        [field]="field"
                        [errorStateMatcher]="errorStateMatcher"
                    ></formly-field>
                    <button
                        *ngIf="!form.disabled"
                        type="button"
                        class="absolute top-2 right-2 p-2"
                        (click)="onRemove(i)"
                    >
                        <mat-icon class="icon-size-6 transition-all hover:text-red" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                    </button>
                </div>
                }

                <formly-validation-message [field]="field" class="text-red-600"></formly-validation-message>

                <button
                    *ngIf="!form.disabled"
                    class="mt-4 flex items-center py-2 px-4 rounded-md cursor-pointer bg-gray-200 text-gray-700 hover:bg-gray-400 transition"
                    type="button"
                    (click)="add()"
                >
                    <span class="font-semibold"> {{ props.addText }} </span>
                </button>




            </div>
        } @else {
            <div class="w-full">
                <div
                    *ngIf="
                        field.fieldGroup && field.fieldGroup.length > 0;
                        else empty_content
                    "
                >
                    <span
                        *ngIf="props.label"
                        class="font-semibold ml-2 mb-2"
                        >{{ props.label }}</span
                    >
                    <div
                        class="mt-2"
                        *ngFor="let field of field.fieldGroup; let i = index"
                    >
                        <formly-field [field]="field"></formly-field>
                    </div>
                </div>
                <ng-template #empty_content>
                    <span class="font-semibold ml-2 mb-6 "
                        >{{ props.label }} - NESSUN ELEMENTO</span
                    >
                </ng-template>
            </div>
        }
    `,
})
export class RepeatTypeComponent extends FieldArrayType {
    onRemove(index: number) {
        this.remove(index);
    }
}
